var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6d64c2f72d7fa97de1441ce329aeee63bd6a95fb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mubazar-frontend@mubazar"]={id:"6d64c2f72d7fa97de1441ce329aeee63bd6a95fb"};
      